import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {PanelOptionInterface} from '@shared/interface';

@Component({
  selector: 'mkad-panel-card-control',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './panel-card-control.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PanelCardControlComponent {
  readonly item = input.required<PanelOptionInterface>();

}
